"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderItemFactory = exports.OrdersFactory = void 0;
const Order_1 = require("../sub-clients/orders/model/Order");
const OrderItem_1 = require("../sub-clients/orders/model/OrderItem");
const types_1 = require("../types");
const DeliveryMethod_1 = require("../sub-clients/common/model/DeliveryMethod");
class OrdersFactory {
    static sample(order) {
        return {
            ...{
                id: '123',
                captionsRequested: true,
                createdAt: new Date(),
                updatedAt: new Date(),
                deliveredAt: new Date(),
                deliveryMethod: DeliveryMethod_1.DeliveryMethod.DOWNLOAD,
                isbnNumber: '123',
                note: 'i am a note',
                searchableOrderId: 'legacy-or-regular-order-id',
                status: Order_1.OrderStatus.READY,
                totalPrice: OrderPriceFactory.sample(),
                userDetails: {
                    authorisingUser: 'a user <A User@gmail.com>',
                    requestingUser: 'a requstor <arequestor@gmail.com',
                    account: { id: 'account-1', name: 'The Account' },
                },
                links: {
                    self: new types_1.Link({ href: 'v1/orders/123' }),
                    update: new types_1.Link({ href: '/v1/orders' }),
                },
                items: [],
            },
            ...order,
        };
    }
}
exports.OrdersFactory = OrdersFactory;
class OrderItemFactory {
    static sample(item) {
        return {
            ...{
                id: 'order-id',
                video: OrderItemFactory.sampleVideo(),
                channel: {
                    id: 'contentPartner-123',
                    name: 'contentPartner-name',
                },
                price: OrderPriceFactory.sample(),
                trim: undefined,
                licenseInfo: {
                    duration: 'A long time',
                    territory: 'Wrexham',
                    warning: 'This is a warning',
                },
                captionsRequested: false,
                links: {
                    updatePrice: new types_1.Link({
                        href: '/v1/orders/123/items/321?price={price}',
                    }),
                    update: new types_1.Link({
                        href: '/v1/orders/123/items/321',
                    }),
                },
            },
            ...item,
        };
    }
    static sampleVideo(video = {}) {
        return {
            id: '123',
            type: 'NEWS',
            title: 'The video title',
            videoReference: 'The video reference',
            maxResolutionAvailable: false,
            captionStatus: OrderItem_1.OrderCaptionStatus.AVAILABLE,
            _links: OrderItemFactory.sampleVideoLinks(video._links),
            ...video,
        };
    }
    static sampleVideoLinks(links = {}) {
        return {
            fullProjection: new types_1.Link({
                href: '/v1/videos/123?projection=full',
            }),
            videoUpload: new types_1.Link({
                href: '/v1/videos/123?projection=full',
            }),
            captionAdmin: new types_1.Link({
                href: '/v1/videos/123?projection=full',
            }),
            ...links,
        };
    }
}
exports.OrderItemFactory = OrderItemFactory;
class OrderPriceFactory {
    static sample(price = {}) {
        return {
            ...{
                currency: 'EUR',
                value: 123,
                displayValue: 'EUR 123',
            },
            ...price,
        };
    }
}
//# sourceMappingURL=OrdersFactory.js.map